export default __webpack_public_path__ + "images/Cajun.94028b.jpg";